module.exports = __webpack_public_path__ + "media/images/brand/photo02-b3d34d44336aa3e145b371fc16442ec8.png";